import DantesShell from "@/components/DantesShell";
import { getDantesContent } from "@/content/dantes";
import { useLang } from "@/context/LanguageContext";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function DantesSecurityPage() {
  const { lang } = useLang();
  const copy = getDantesContent(lang);
  usePageMeta("Dantes Security", copy.securityPage.intro);

  return (
    <DantesShell section="security">
      <section className="mx-auto max-w-[1240px] px-6 py-16 md:px-10 md:py-24">
        <p className="font-sans text-[11px] uppercase tracking-[0.18em] text-[var(--gold)]">
          Security
        </p>
        <h1 className="mt-4 max-w-[12ch] font-serif text-[clamp(2.8rem,7vw,5.5rem)] leading-[0.92]">
          {copy.securityPage.title}
        </h1>
        <p className="mt-6 max-w-[56ch] font-sans text-[16px] leading-8 text-[var(--text-secondary)]">
          {copy.securityPage.intro}
        </p>

        <div className="mt-12 space-y-6">
          {copy.securityPage.sections.map(([title, body]) => (
            <div key={title} className="grid gap-4 border-t border-[var(--rule)] pt-6 md:grid-cols-[220px_minmax(0,1fr)]">
              <div className="font-sans text-[11px] uppercase tracking-[0.16em] text-[var(--gold)]">
                {title}
              </div>
              <div className="font-sans text-[15px] leading-8 text-[var(--text-primary)]">{body}</div>
            </div>
          ))}
        </div>

        <div className="mt-12 border-t border-[var(--rule)] pt-8">
          <p className="max-w-[56ch] font-sans text-[13px] leading-7 text-[var(--text-tertiary)]">
            {copy.footer.disclaimer}
          </p>
        </div>
      </section>
    </DantesShell>
  );
}
